import Carousel from "react-native-reanimated-carousel";
import FilterSlide from "../FilterSlide";
import TypeSlide from "../TypeSlide/TypeSlide";
import { Box, View } from "native-base";
import React, { useCallback } from "react";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
import { useWindowDimensions } from "react-native";
import { CatalogTypeItem } from "../../types";
import { sortCatalogTypes } from "../../utils";
import { BackButtonBackHome } from "../../../Universal/Buttons/BackButtonBackHomeModified";
import {
  useCatalogCarouselState,
  useCatalogFilterState,
  useCatalogUrlState,
} from "./hooks";

const RenderCatalog: React.FC<any> = ({ navigation, contentHeight, isFocused }) => {
  const { catalog_Types, allUnitData } = useAppContext();
  const { width, height } = useWindowDimensions();
  const rawCatalogTypes = (catalog_Types as any) as CatalogTypeItem[] | undefined;
  const catalogTypes = React.useMemo(
    () => (rawCatalogTypes ? sortCatalogTypes(rawCatalogTypes) : undefined),
    [rawCatalogTypes]
  );

  const {
    selectedTypeIndex,
    setSelectedTypeIndex,
    filters,
    setFilters,
    selectedType,
    clearFilters,
    toggleFilterValue,
    allUnitsDataForType,
    availableColors,
    availableTypes,
    availablePrims,
    availableCollections,
    filterConfig,
  } = useCatalogFilterState({
    catalogTypes,
    allUnitData,
  });

  const {
    carouselRef,
    slide2Ready,
    setActiveSlide,
    setSlide2Ready,
    isLeavingRef,
    goToFilters,
    handleSnap,
  } = useCatalogCarouselState({
    navigation,
    isFocused,
    selectedTypeIndex,
  });

  useCatalogUrlState({
    catalogTypes,
    selectedTypeIndex,
    setSelectedTypeIndex,
    filters,
    setFilters,
    carouselRef,
    setActiveSlide,
    setSlide2Ready,
    isFocused,
    isLeavingRef,
    availableColors,
    availableTypes,
    availablePrims,
    availableCollections,
  });

  const handleSelectType = useCallback(
    (index: number) => {
      setSelectedTypeIndex(index);
      setFilters({ colors: [], types: [], prims: [], collections: [] });
      goToFilters();
    },
    [goToFilters, setFilters, setSelectedTypeIndex]
  );

  const handleBackToTypes = useCallback(() => {
    setSlide2Ready(false);
    setSelectedTypeIndex(null);
    setFilters({ colors: [], types: [], prims: [], collections: [] });
    carouselRef.current?.scrollTo({ index: 0, animated: true });
    setActiveSlide(0);
  }, [carouselRef, setActiveSlide, setFilters, setSelectedTypeIndex, setSlide2Ready]);

  const carouselHeight = contentHeight ?? height;

  return (
    <Box flex={1}>
      <View style={{ position: "absolute", width: "100%", left: 0, zIndex: 10000 }}>
        <BackButtonBackHome
          navigation={navigation}
          onPress={selectedTypeIndex == null ? undefined : handleBackToTypes}
        />
      </View>

      <Carousel
        ref={carouselRef}
        width={width}
        height={carouselHeight}
        data={[0, 1]}
        loop={false}
        enabled={false}
        onSnapToItem={handleSnap}
        renderItem={({ index }) =>
          index === 0 ? (
            <TypeSlide
              catalogTypes={catalogTypes || []}
              selectedTypeIndex={selectedTypeIndex}
              onSelectType={handleSelectType}
              height={height}
              width={width}
            />
          ) : (
            <FilterSlide
              enabled={slide2Ready}
              isLeavingRef={isLeavingRef}
              selectedType={selectedType}
              allUnitsData={allUnitsDataForType}
              filters={filters}
              filterConfig={filterConfig}
              toggleFilterValue={toggleFilterValue}
              clearFilters={clearFilters}
              onBackToTypes={handleBackToTypes}
              isFocused={isFocused}
              navigation={navigation}
            />
          )
        }
      />
    </Box>
  );
};

export default React.memo(RenderCatalog)
